export const secondaryWholesalers = ['bluepax_secondary',
    // Secondary Insert
    'capital_secondary',
    'rx_supply_secondary',
    'bloodworth_secondary',
    'keysource_secondary',
    'toprx_secondary',
    'auburn_secondary',
    'ipc_secondary',
    'quest_secondary',
    // PM-2571: `mutual_drug_secondary` was here. Mutual Drug is a primary only, and the
    // secondary key never was a user-selectable secondary — it has no `SecondaryWholesalerName`
    // entry and `nonShoppableWholesalers` records it as EDI-810-ingestion-only. Its data moved
    // to `mutual_drug_primary`; see the migration for the per-field mapping.
    'masters_secondary'];
export var WholesalerKeys;
(function (WholesalerKeys) {
    WholesalerKeys["BLUPAX"] = "bluepax_secondary";
    WholesalerKeys["CAPITAL"] = "capital_secondary";
    WholesalerKeys["RXSUPPLY"] = "rx_supply_secondary";
    WholesalerKeys["BLOODWORTH"] = "bloodworth_secondary";
    WholesalerKeys["KEYSOURCE"] = "keysource_secondary";
    WholesalerKeys["TOPRX"] = "toprx_secondary";
    WholesalerKeys["AUBURN"] = "auburn_secondary";
    WholesalerKeys["IPC"] = "ipc_secondary";
    WholesalerKeys["QUEST"] = "quest_secondary";
    WholesalerKeys["MASTERS"] = "masters_secondary";
    WholesalerKeys["MCKESSON"] = "mckesson_primary";
    WholesalerKeys["CARDINAL"] = "cardinal_primary";
    // PM-2035: Cencora is the 2023 rebrand of AmerisourceBergen, not a second
    // wholesaler. The enum previously carried BOTH `amerisource_primary` and
    // `cencora_primary`; the legacy key is gone and this is the single canonical one.
    // Neither key had a wholesalers sub-schema, so 0 of 1248 prod wholesaler documents
    // carried either — see the migration for the compliance-collection rename.
    WholesalerKeys["CENCORA"] = "cencora_primary";
    WholesalerKeys["KINRAY"] = "kinray_primary";
    WholesalerKeys["MORRISDICKSON"] = "morris_dickson_primary";
    // PM-2457 added this alongside a `MUTUALDRUG = 'mutual_drug_secondary'` member, because
    // Mutual Drug was then on both key lists. PM-2571 removed the secondary, so this is now
    // the only Mutual Drug key. The name keeps its PRIMARY suffix: renaming a shipped enum
    // member buys nothing here, and the suffix still says which list it belongs to.
    WholesalerKeys["MUTUALDRUGPRIMARY"] = "mutual_drug_primary";
})(WholesalerKeys || (WholesalerKeys = {}));
export const primaryWholesalers = ['mckesson_primary',
    // Primary Insert
    'cardinal_primary',
    'kinray_primary',
    'cencora_primary',
    'morris_dickson_primary',
    // PM-2457 added this while `mutual_drug_secondary` still existed, so the two were kept
    // deliberately separate: different storage fields (`mutualDrugPrimaryAccountNumber`, NOT
    // `mutualDrugAccountNumber`), because conflating a secondary account number with a primary
    // one is PM-1392.
    //
    // PM-2571 settled the question the split was hedging: Mutual Drug is a primary only. The
    // secondary key is gone and this is the single Mutual Drug key, so the EDI 810 ingestion
    // lane now hangs off this one. Still not shoppable — see `nonShoppableWholesalers`.
    'mutual_drug_primary',
];
export const isPrimaryWholesaler = (wholesaler) => {
    return primaryWholesalers.includes(wholesaler);
};
export const wholesalers = [...secondaryWholesalers, ...primaryWholesalers];
